import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { api } from "@/api";
import { REVIEWS_FALLBACK } from "@/data";

export const Reviews = () => {
  const [reviews, setReviews] = useState(REVIEWS_FALLBACK);

  useEffect(() => {
    api.get("/reviews").then((r) => {
      if (Array.isArray(r.data) && r.data.length) setReviews(r.data);
    }).catch(() => {});
  }, []);

  return (
    <section id="reviews" data-testid="reviews-section" className="relative py-24 sm:py-32 bg-cosmic-elevated/40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-12">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-cosmic-pink">Mission Log</span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
            Loved across the <span className="text-gradient-candy">galaxy</span>
          </h2>
        </div>

        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="reviews-grid">
          {reviews.map((r, i) => (
            <motion.blockquote
              key={r.review_id || r.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="glass rounded-2xl p-6"
              data-testid={`review-card-${i}`}>
              <div className="flex gap-1">
                {Array.from({ length: r.rating || 5 }).map((_, s) => (
                  <Star key={s} size={15} className="fill-cosmic-yellow text-cosmic-yellow" />
                ))}
              </div>
              <p className="mt-4 text-sm text-slate-300 leading-relaxed">“{r.text}”</p>
              <footer className="mt-5 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full font-display text-sm font-black text-cosmic-base"
                  style={{ background: r.color || "#FF2A85" }}>
                  {r.name.charAt(0)}
                </span>
                <div>
                  <div className="text-sm font-bold text-white">{r.name}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-slate-400">{r.event}</div>
                </div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
